//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const moment = require("moment-timezone");
import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
} from "@/services/constants";

export default {
  name: "MasterPatentNew",
  components: { SuccessDialog, SuccessDialogPush, pdf: pdfvuer },
  data() {
    return {
      sendBilling: "Reply All",
      sendBillingList: ["Reply All", "Specific Email", "Link"],
      sendBillingDetail: "",
      customer_list: [],
      customer_selected: null,
      customer_address: "",

      fileindex_cer: -1,
      preview_list_cer: [],
      image_list_cer: [],
      filename_cer: [],
      getpreview_list_cer: [],
      preview_list2_cer: [],
      checkfileeadd_cer: false,

      timelineEvents: [
        {
          time: "16/06/68",
          title: "Check-in",
          description: "Employee arrived at office.",
          color: "green",
        },
        {
          time: "17/06/68",
          title: "Team Meeting",
          description: "Discussed project milestones.",
          color: "blue",
        },
        {
          time: "18/06/68",
          title: "Lunch Break",
          description: "Break time until 13:00.",
          color: "orange",
        },
        {
          time: "19/06/68",
          title: "Client Call",
          description: "Call with ABC Corporation.",
          color: "purple",
        },
        {
          time: "50/06/68",
          title: "Check-out",
          description: "End of workday.",
          color: "red",
        },
      ],

      other_sub: "",
      priorityList: [
        {
          number: "",
          date: "",
          country: "",
          menu: false,
        },
      ],
      preview_list2: [],
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDelete_cer: false,
      dialogDeleteimage: false,
      filename: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,

      country_list: [],
      isShowPassword: false,
      fullPage: true,
      objecttype_list: [],
      contact_owner_list: [],
      contact_agent_list: [],
      contact_associate_list: [],
      menuadd: false,
      menuaddAppD: false,
      menuaddptd: false,
      menuInterNew: false,
      menuaddpubd: false,
      menuadderdd: false,
      menuaddeaxmd: false,
      menuadderd: false,
      menuaddlapd: false,
      menuaddnad: false,
      menuaddnadfinalDatePayment: false,
      menuaddnrd: false,
      menuaddlra: false,
      menuaddndd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAdd: false,
      main_id: 0,
      mode_operation: "Create",
      date_of_application: null,
      date_of_patent: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      international_filing_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_publishing: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      exam_request_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      exam_request_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_examination: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      last_annuity_paid: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_annuity_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      final_due_date_for_next_payment: null,
      next_renewal: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      last_renewal_att: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      type_list: [
        { type_name: "Design", type_number: "1" },
        { type_name: "Invention", type_number: "2" },
        { type_name: "Petty", type_number: "3" },
        // { type_name: "Invention / PCT", type_number: "4" },
      ],
      subtype_list: ["PARIS", "PCT", "Other"],
      next_dl: ["7", "30", "60", "Manual Input"],
      // eslint-disable-next-line prettier/prettier
      latest_list: [
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
      ],
      patent_status_list: [
        {
          patent_status_name: "Nil (Unrecognised Status)",
          patent_status_id: 1,
        },
        { patent_status_name: "Pending", patent_status_id: 2 },
        { patent_status_name: "Registered", patent_status_id: 3 },
        { patent_status_name: "Renewal Pending", patent_status_id: 5 },
        { patent_status_name: "Closed", patent_status_id: 6 },
      ],
      owner_contact_list: [],
      associate_address: "",
      agent_address: "",
      itemdata: {
        sub_type: "",
        tm_type: 0,
        file_no: "",
        title: "",
        name_of_client: "",
        app_no: "",
        patent_no: "",
        city: "",
        owner_contact: 0,
        agent_contact: 0,
        associate_contact: 0,
        val_no: "",
        page_no: "",
        priority_number: "",
        status: 0,
        type: "",
        remark: "",
        dead_last_annuity_paid: "",
        client_ref: "",
        good_service: "",
        registration_condition: "",
        owner_address: "",
        agent_address: "",
        associate_address: "",
        date_of_patent: null,
        international_filing_date: null,
        date_of_application: null,
        date_of_publishing: null,
        date_of_examination: null,
        next_renewal: null,
        last_renewal_att: null,
        next_deadline: null,
        exam_request_deadline: null,
        exam_request_date: null,
        next_annuity_date: null,
        final_due_date_for_next_payment: null,
        last_annuity_paid: null,
        international_filing_number: "",
      },
    };
  },
  async mounted() {
    await this.loadCustomerComboboxMetter();
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loaddata();
    await this.loaddatacountry();
    this.$hideLoader();
  },
  methods: {
    //onChanege customer filter full_address by id
    async onSelectComboboxMetterChange(value) {
      // console.log(`onSelectComboboxMetterChange: ${value}`);
      // console.log(`customer_list:${JSON.stringify(this.customer_list)}`);

      const selectedCustomer = this.customer_list.find(
        (customer) => customer.id === value
      );
      this.customer_address = selectedCustomer
        ? selectedCustomer.full_address
        : "";
    },
    async loadCustomerComboboxMetter() {
      const result = await api.getCustomerComboboxByMetter(
        localStorage.getItem(server.COMPANYID)
      );
      // console.log(`loadCustomerComboboxMetter: ${JSON.stringify(result.data)}`);

      this.customer_list = result.data;
    },
    onApplicationDateChanged() {
      if (this.date_of_application) {
        if (
          this.itemdata.dead_last_annuity_paid != "" &&
          this.itemdata.dead_last_annuity_paid
        ) {
          const parts = this.date_of_application.split("-");
          const date = new Date(+parts[0], parts[1] - 1, +parts[2]);

          const yearsToAdd = Number(this.itemdata.dead_last_annuity_paid) - 1;

          const originalDay = date.getDate();
          date.setFullYear(date.getFullYear() + yearsToAdd);

          if (date.getDate() < originalDay) {
            date.setDate(0);
          }

          const y = date.getFullYear();
          const m = String(date.getMonth() + 1).padStart(2, "0");
          const d = String(date.getDate()).padStart(2, "0");

          this.itemdata.next_annuity_date = `${d}/${m}/${y}`;
          this.next_annuity_date = `${y}-${m}-${d}`;

          this.updateFinalDueDateFromNextAnnuity();
        }
      }
    },
    updateFinalDueDateFromNextAnnuity() {
      var dateString = this.next_annuity_date;

      if (!dateString) return "";

      const [year, month, day] = dateString.split("-").map(Number);
      const date = new Date(year, month - 1, day); // สร้าง Date

      date.setDate(date.getDate() + 60); // บวก 60 วัน

      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");

      this.itemdata.final_due_date_for_next_payment = `${d}/${m}/${y}`;
    },
    formatDatePriority(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDateInputPriority(value) {
      if (!value) return "";
      const parts = value.split("/");
      if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return value; // fallback ถ้า format ไม่ถูกต้อง
    },
    addPriority() {
      this.priorityList.push({
        number: "",
        date: "",
        country: "",
        menu: false,
      });
    },
    removePriority(index) {
      this.priorityList.splice(index, 1);
    },
    async popupdeletefile(index) {
      this.fileindex = index;
      this.dialogDelete = true;
    },
    async popupdeletefile_cer(index) {
      this.fileindex_cer = index;
      this.dialogDelete_cer = true;
    },
    async closeDelete() {
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async closeDelete_cer() {
      this.fileindex_cer = -1;
      this.dialogDelete_cer = false;
    },
    async deleteItemConfirm() {
      this.preview_list2 = [];
      this.getpreview_list.splice(this.fileindex, 1);
      this.image_list.splice(this.fileindex, 1);
      await this.getPdfforAdd(this.getpreview_list);

      this.filename.splice(this.fileindex, 1);
      this.preview_list2 = this.preview_list;
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm_cer() {
      this.preview_list2_cer = [];
      this.getpreview_list_cer.splice(this.fileindex_cer, 1);
      this.image_list_cer.splice(this.fileindex_cer, 1);
      await this.getPdfforAdd_cer(this.getpreview_list_cer);

      this.filename_cer.splice(this.fileindex_cer, 1);
      this.preview_list2_cer = this.preview_list_cer;
      this.fileindex_cer = -1;
      this.dialogDelete_cer = false;
    },

    async popupdeleteimage() {
      this.dialogDeleteimage = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimage() {
      this.checkimageadd = false;
      this.image = null;
      this.previewimage = "";
      this.imagename = "";
      this.dialogDeleteimage = false;
    },
    async popuppreviewfile(fileindex) {
      let pdf_newTab = window.open("");
      pdf_newTab.document.write(
        "<html><head><title>pdf file</title></head><body><iframe title='MY title'  width='100%' height='100%' src='" +
        this.getpreview_list[fileindex] +
        "'></iframe></body></html>"
      );

      return;
    },
    async popuppreviewfile_cer(fileindex_cer) {
      let pdf_newTab_cer = window.open("");
      pdf_newTab_cer.document.write(
        "<html><head><title>pdf file</title></head><body><iframe title='MY title' width='100%' height='100%' src='" +
        this.getpreview_list_cer[fileindex_cer] +
        "'></iframe></body></html>"
      );
      return;
    },

    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    async popuppreviewimage() {
      const imageTab = window.open("");
      imageTab.document.write(`
        <html>
          <head>
            <title>Preview Image</title>
          </head>
          <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
            <img src="${this.previewimage}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
          </body>
        </html>
      `);
      return;
    },
    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewimage = e.target.result;
          this.checkimageadd = true;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }

      this.imagename = this.image.name;
    },
    // ฟังก์ชันตรวจสอบชื่อซ้ำทั้ง 2 ชุด และคืนชื่อใหม่ที่ไม่ซ้ำ
    // ฟังก์ชันตรวจสอบชื่อซ้ำในทั้ง filename และ filename_cer
    generateUniqueFileName(originalName) {
      let newName = originalName;
      let nameIndex = 1;
      const allNames = [...this.filename, ...this.filename_cer];

      while (allNames.includes(newName)) {
        const dotIndex = originalName.lastIndexOf(".");
        if (dotIndex !== -1) {
          newName = `${originalName.substring(
            0,
            dotIndex
          )}-${nameIndex}${originalName.substring(dotIndex)}`;
        } else {
          newName = `${originalName}-${nameIndex}`;
        }
        nameIndex++;
      }
      return newName;
    },

    async previewMultiImage(event) {
      this.preview_list = [];
      this.filename = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;

      if (input.files) {
        while (count--) {
          var reader = new FileReader();

          reader.onload = (e) => {
            this.getpreview_list.push(e.target.result);
            this.preview_list.push(e.target.result);
          };

          if (input.files[index].type === "application/pdf") {
            let originalFile = input.files[index];
            let originalName = originalFile.name;
            let newName = this.generateUniqueFileName(originalName);

            // Clone ไฟล์พร้อมชื่อใหม่
            let renamedFile = new File([originalFile], newName, {
              type: originalFile.type,
            });

            this.image_list.push(renamedFile);
            this.filename.push(newName);

            reader.readAsDataURL(renamedFile);
          }
          index++;
        }
      }
      await this.getPdfforAdd(this.getpreview_list);
      this.preview_list2 = this.preview_list;
      this.checkfileeadd = true;
    },

    async previewMultiImage_cer(event) {
      this.preview_list_cer = [];
      this.filename_cer = [];
      var input_cer = event.target;
      var count_cer = input_cer.files.length;
      var index_cer = 0;

      if (input_cer.files) {
        while (count_cer--) {
          var reader_cer = new FileReader();

          reader_cer.onload = (e) => {
            this.getpreview_list_cer.push(e.target.result);
            this.preview_list_cer.push(e.target.result);
          };

          if (input_cer.files[index_cer].type === "application/pdf") {
            let originalFile_cer = input_cer.files[index_cer];
            let originalName_cer = originalFile_cer.name;
            let newName_cer = this.generateUniqueFileName(originalName_cer);

            // Clone ไฟล์พร้อมชื่อใหม่
            let renamedFile_cer = new File([originalFile_cer], newName_cer, {
              type: originalFile_cer.type,
            });

            this.image_list_cer.push(renamedFile_cer);
            this.filename_cer.push(newName_cer);

            reader_cer.readAsDataURL(renamedFile_cer);
          }
          index_cer++;
        }
      }
      await this.getPdfforAdd_cer(this.getpreview_list_cer);
      this.preview_list2_cer = this.preview_list_cer;
      this.checkfileeadd_cer = true;
    },

    reset: function () {
      this.image = null;
      this.previewimage = null;
      this.image_list = [];
      this.preview_list = [];
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },
    async getPdfforAdd(item) {
      this.preview_list = [];
      let getfile = [];
      getfile = item;
      getfile.forEach((file, index) => {
        this.preview_list.push(pdfvuer.createLoadingTask(`${file}`));
      });
      this.preview_list.forEach((item, index) => {
        item.then((pdf) => {
          this.numPages = pdf.numPages;
          // window.onscroll = function() {
          //   changePage();
          //   stickyNav();
          // };
          // Get the offset position of the navbar
          // var sticky = $("#buttons")[0].offsetTop;
          // // Add the sticky class to the this.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
          // function stickyNav() {
          //   if (window.pageYOffset >= sticky) {
          //     $("#buttons")[0].classList.remove("hidden");
          //   } else {
          //     $("#buttons")[0].classList.add("hidden");
          //   }
          // }
          function changePage() {
            var i = 1,
              count = Number(pdf.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i + 1))
              ) {
                this.page = i;
              }
              i++;
            } while (i < count);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i))
            ) {
              this.page = i;
            }
          }
        });
      });
      this.checkfileadd = true;
    },
    async getPdfforAdd_cer(item_cer) {
      this.preview_list_cer = [];
      let getfile_cer = [];
      getfile_cer = item_cer;
      getfile_cer.forEach((file_cer, index_cer) => {
        this.preview_list_cer.push(pdfvuer.createLoadingTask(`${file_cer}`));
      });
      this.preview_list_cer.forEach((item_cer, index_cer) => {
        item_cer.then((pdf_cer) => {
          this.numPages_cer = pdf_cer.numPages;
          function changePage_cer() {
            var i_cer = 1,
              count_cer = Number(pdf_cer.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i_cer)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i_cer + 1))
              ) {
                this.page_cer = i_cer;
              }
              i_cer++;
            } while (i_cer < count_cer);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i_cer))
            ) {
              this.page_cer = i_cer;
            }
          }
        });
      });
      this.checkfileadd_cer = true;
    },
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    findPos(obj) {
      return obj.offsetTop;
    },

    async loaddata() {
      if (this.$route.params.masterpt_id) {
        this.mode_operation = "Update";
        this.main_id = this.$route.params.masterpt_id;

        const result = await api.getByIdMasterPT(this.main_id);
        const editItem = result.data;
        this.itemdata = editItem[0];
        this.itemdata.date_of_application = this.formatDate(
          this.itemdata.date_of_application
        );
        this.itemdata.date_of_patent = this.formatDate(
          this.itemdata.date_of_patent
        );
        this.itemdata.date_of_publishing = this.formatDate(
          this.itemdata.date_of_publishing
        );
        this.itemdata.exam_request_date = this.formatDate(
          this.itemdata.exam_request_date
        );
        this.itemdata.exam_request_deadline = this.formatDate(
          this.itemdata.exam_request_deadline
        );
        this.itemdata.date_of_examination = this.formatDate(
          this.itemdata.date_of_examination
        );
        this.itemdata.next_deadline = this.formatDate(
          this.itemdata.next_deadline
        );
        this.itemdata.last_annuity_paid = this.formatDate(
          this.itemdata.last_annuity_paid
        );
        this.itemdata.next_annuity_date = this.formatDate(
          this.itemdata.next_annuity_date
        );
        this.itemdata.final_due_date_for_next_payment = this.formatDate(
          this.itemdata.final_due_date_for_next_payment
        );
        this.itemdata.next_renewal = this.formatDate(
          this.itemdata.next_renewal
        );
        this.itemdata.last_renewal_att = this.formatDate(
          this.itemdata.last_renewal_att
        );

        // this.onSelectOwnerChange(editItem[0].owner_contact);
        this.onSelectAgentChange(editItem[0].agent_contact);
        this.onSelectAssociateChange(editItem[0].associate_contact);
      }
    },
    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(2);

      this.objecttype_list = result.data;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
    },
    async loaddatacountry() {
      const result = await api.getAllCountry();
      this.country_list = result.data;
    },
    //  async saveItem(mode) {
    //     console.log(this.image_list)
    //     console.log(this.image_list_cer)
    //  },
    async saveItem(mode) {
      if (this.itemdata.sub_type != "") {
        if (this.itemdata.sub_type == "Other") {
          this.itemdata.sub_type = this.other_sub;
        } else {
          this.itemdata.sub_type = this.itemdata.sub_type;
        }
      }

      if (this.itemdata.tm_type == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Object Type",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.itemdata.file_no) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter File No.",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.owner_contact_list.length == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter Client Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.itemdata.sub_type != "" && this.itemdata.sub_type == "PCT") {
        if (this.itemdata.international_filing_number == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Enter International Filing Number",
            "text-h5 red--text text-center"
          );
          return;
        }
        if (!this.itemdata.international_filing_date) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Failed",
            "Please Enter International Filing Date",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
      this.$showLoader();
      var contact_id = this.owner_contact_list
        .map((item) => item.contact_id)
        .join(",");
      this.itemdata.owner_contact = contact_id;

      if (this.mode_operation == "Create") {
        this.itemdata.date_of_application = this.changeformatDatetoinsert(
          this.itemdata.date_of_application
        );
        this.itemdata.date_of_patent = this.changeformatDatetoinsert(
          this.itemdata.date_of_patent
        );
        this.itemdata.date_of_publishing = this.changeformatDatetoinsert(
          this.itemdata.date_of_publishing
        );
        this.itemdata.exam_request_date = this.changeformatDatetoinsert(
          this.itemdata.exam_request_date
        );
        this.itemdata.exam_request_deadline = this.changeformatDatetoinsert(
          this.itemdata.exam_request_deadline
        );
        this.itemdata.date_of_examination = this.changeformatDatetoinsert(
          this.itemdata.date_of_examination
        );
        this.itemdata.next_deadline = this.changeformatDatetoinsert(
          this.itemdata.next_deadline
        );
        this.itemdata.last_annuity_paid = this.changeformatDatetoinsert(
          this.itemdata.last_annuity_paid
        );
        this.itemdata.next_annuity_date = this.changeformatDatetoinsert(
          this.itemdata.next_annuity_date
        );
        this.itemdata.final_due_date_for_next_payment =
          this.changeformatDatetoinsert(
            this.itemdata.final_due_date_for_next_payment
          );
        this.itemdata.next_renewal = this.changeformatDatetoinsert(
          this.itemdata.next_renewal
        );
        this.itemdata.last_renewal_att = this.changeformatDatetoinsert(
          this.itemdata.last_renewal_att
        );
        //alert("testcreate");
        // this.$showLoader();

        let formData = new FormData();
        formData.append(`file`, this.image);
        this.image_list.forEach((x, index) => {
          formData.append(`file`, x);
        });

        formData.append("tm_type", this.itemdata.tm_type);
        formData.append("file_no", this.itemdata.file_no.toUpperCase());
        formData.append("title", this.itemdata.title);
        formData.append("send_billing", this.sendBilling);
        if (this.sendBilling == "Reply All") {
          formData.append("send_billing_detail", "");
        } else {
          formData.append("send_billing_detail", this.sendBillingDetail);
        }
        const name_of_client = this.owner_contact_list
          .map((item) => item.contact_name)
          .join(", ");
        formData.append("name_of_client", name_of_client);

        formData.append("app_no", this.itemdata.app_no);
        formData.append("patent_no", this.itemdata.patent_no);
        formData.append("city", this.itemdata.city);

        if (this.itemdata.owner_contact) {
          formData.append("owner_contact", this.itemdata.owner_contact);
        }

        if (this.itemdata.agent_contact) {
          formData.append("agent_contact", this.itemdata.agent_contact);
        }

        if (this.itemdata.associate_contact) {
          formData.append("associate_contact", this.itemdata.associate_contact);
        }

        formData.append(
          "create_by",
          Number(localStorage.getItem(server.USER_ID))
        );
        formData.append("val_no", this.itemdata.val_no);
        formData.append("page_no", this.itemdata.page_no);
        formData.append("priority_number", this.itemdata.priority_number);
        formData.append("status", this.itemdata.status);
        formData.append("type", this.itemdata.type);
        formData.append("sub_type", this.itemdata.sub_type);
        if (this.itemdata.sub_type != "" && this.itemdata.sub_type == "PCT") {
          formData.append(
            "international_filing_number",
            this.itemdata.international_filing_number
          );
          formData.append(
            "international_filing_date",
            this.international_filing_date
          );
        } else {
          formData.append("international_filing_number", "");
          formData.append("international_filing_date", "");
        }
        formData.append("remark", this.itemdata.remark);
        formData.append(
          "dead_last_annuity_paid",
          this.itemdata.dead_last_annuity_paid
        );
        formData.append("client_ref", this.itemdata.client_ref);
        formData.append("good_service", this.itemdata.good_service);
        formData.append(
          "registration_condition",
          this.itemdata.registration_condition
        );
        formData.append("owner_address", this.itemdata.owner_address);
        formData.append("agent_address", this.itemdata.agent_address);
        formData.append("associate_address", this.itemdata.associate_address);
        if (this.itemdata.date_of_patent) {
          formData.append("date_of_patent", this.itemdata.date_of_patent);
        }
        if (this.itemdata.date_of_application) {
          formData.append(
            "date_of_application",
            this.itemdata.date_of_application
          );
        }

        if (this.itemdata.date_of_publishing) {
          formData.append(
            "date_of_publishing",
            this.itemdata.date_of_publishing
          );
        }

        if (this.itemdata.date_of_examination) {
          formData.append(
            "date_of_examination",
            this.itemdata.date_of_examination
          );
        }

        if (this.itemdata.next_renewal) {
          formData.append("next_renewal", this.itemdata.next_renewal);
        }

        if (this.itemdata.last_renewal_att) {
          formData.append("last_renewal_att", this.itemdata.last_renewal_att);
        }

        if (this.itemdata.next_deadline) {
          formData.append("next_deadline", this.itemdata.next_deadline);
        }

        if (this.itemdata.exam_request_deadline) {
          formData.append(
            "exam_request_deadline",
            this.itemdata.exam_request_deadline
          );
        }

        if (this.itemdata.exam_request_date) {
          formData.append("exam_request_date", this.itemdata.exam_request_date);
        }

        if (this.itemdata.next_annuity_date) {
          formData.append("next_annuity_date", this.itemdata.next_annuity_date);
        }
        if (this.itemdata.final_due_date_for_next_payment) {
          formData.append(
            "final_due_date_for_next_payment",
            this.itemdata.final_due_date_for_next_payment
          );
        }

        if (this.itemdata.last_annuity_paid) {
          formData.append("last_annuity_paid", this.itemdata.last_annuity_paid);
        }

        if (this.customer_selected) {
          formData.append("cus_billing_id", this.customer_selected);
        } else {
          formData.append("cus_billing_id", null);
        }

        // const create_masterpt = await api.createMasterPT(this.itemdata);
        const create_masterpt = await api.createMasterPT_V2(formData);

        if (create_masterpt.status == 203) {
          this.$hideLoader();
          if (create_masterpt.data.file_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check File No.",
              "text-h5 red--text text-center"
            );
            return;
          }
          if (create_masterpt.data.app_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check Application No.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
        if (create_masterpt.status == 200 || create_masterpt.status == 201) {
          this.$hideLoader();
          for (const [index, item] of this.priorityList.entries()) {
            var data_add_riority = {
              masterpt_id: create_masterpt.data.masterpt_id,
              priority_number: item.number,
              priority_date: item.date,
              priority_country: item.country,
            };

            if (item.number != "" || item.date != "" || item.country != "") {
              await api.createMASTERPT_PRIORITY(data_add_riority);
            }
          }

          if (this.image_list_cer && this.image_list_cer.length > 0) {
            let formDataCer = new FormData();

            let fileNames = this.image_list_cer
              .map((file) => file.name)
              .join(",");
            formDataCer.append("file_cer", fileNames);

            this.image_list_cer.forEach((file, index) => {
              formDataCer.append("file", file);
            });

            var add_file = await api.upload_cer(
              create_masterpt.data.masterpt_id,
              formDataCer
            );
          }

          let dataAdd = {
            user_id: localStorage.getItem(server.USER_ID),
            log_in_out_id: localStorage.getItem(server.LOGIN_ID),
            action: "Create",
            table_name: "masterpt",
            table_id: create_masterpt.data.masterpt_id,
            date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          };

          await api.addTransectionLog(dataAdd);

          var dataEditLog = {
            last_update: moment()
              .tz("Asia/Bangkok")
              .format("YYYY-MM-DD HH:mm:ss"),
          };
          await api.updateLogInOutLog(
            localStorage.getItem(server.LOGIN_ID),
            dataEditLog
          );

          if (mode == "createAp") {
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              `/appointment-patent-new/${this.itemdata.file_no}`
            );
          } else {
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              "/master-patent-list"
            );
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "save data",
            "can't save data",
            "text-h5 red--text text-center"
          );
        }
      }
      // if (this.mode_operation == "Update") {
      //   this.itemdata.date_of_application = this.changeformatDatetoinsert(
      //     this.itemdata.date_of_application
      //   );
      //   this.itemdata.date_of_patent = this.changeformatDatetoinsert(
      //     this.itemdata.date_of_patent
      //   );
      //   this.itemdata.date_of_publishing = this.changeformatDatetoinsert(
      //     this.itemdata.date_of_publishing
      //   );
      //   this.itemdata.exam_request_date = this.changeformatDatetoinsert(
      //     this.itemdata.exam_request_date
      //   );
      //   this.itemdata.exam_request_deadline = this.changeformatDatetoinsert(
      //     this.itemdata.exam_request_deadline
      //   );
      //   this.itemdata.date_of_examination = this.changeformatDatetoinsert(
      //     this.itemdata.date_of_examination
      //   );
      //   this.itemdata.next_deadline = this.changeformatDatetoinsert(
      //     this.itemdata.next_deadline
      //   );
      //   this.itemdata.last_annuity_paid = this.changeformatDatetoinsert(
      //     this.itemdata.last_annuity_paid
      //   );
      //   this.itemdata.next_annuity_date = this.changeformatDatetoinsert(
      //     this.itemdata.next_annuity_date
      //   );
      //   this.itemdata.final_due_date_for_next_payment =
      //     this.changeformatDatetoinsert(
      //       this.itemdata.final_due_date_for_next_payment
      //     );
      //   this.itemdata.next_renewal = this.changeformatDatetoinsert(
      //     this.itemdata.next_renewal
      //   );
      //   this.itemdata.last_renewal_att = this.changeformatDatetoinsert(
      //     this.itemdata.last_renewal_att
      //   );

      //   this.$showLoader();
      //   const update_masterpt = await api.updateMasterPt(
      //     this.main_id,
      //     this.itemdata
      //   );
      //   await api.AppointmentUpdateclientname(this.itemdata.file_no, {
      //     trademark_name: this.itemdata.name_of_client,
      //   });
      //   this.$hideLoader();

      //   if (update_masterpt.status == 203) {
      //     if (update_masterpt.data.file_no) {
      //       this.$store.state.global_dialog = true;
      //       this.setupAlertDialog(
      //         true,
      //         "data duplicate ",
      //         "please check File No.",
      //         "text-h5 red--text text-center"
      //       );
      //       return;
      //     }
      //     if (update_masterpt.data.app_no) {
      //       this.$store.state.global_dialog = true;
      //       this.setupAlertDialog(
      //         true,
      //         "data duplicate ",
      //         "please check Application No.",
      //         "text-h5 red--text text-center"
      //       );
      //       return;
      //     }
      //   }
      //   if (update_masterpt.status == 200 || update_masterpt.status == 201) {
      //     this.$store.state.global_push_dialog = true;
      //     this.setupAlertDialogPush(
      //       true,
      //       "save data",
      //       "save data success",
      //       "text-h5 green--text text-center",
      //       "/master-patent-list"
      //     );
      //   } else {
      //     this.$store.state.global_dialog = true;
      //     this.setupAlertDialog(
      //       true,
      //       "save data",
      //       "can't save data",
      //       "text-h5 red--text text-center"
      //     );
      //   }
      // }
      this.$hideLoader();
    },
    async onSelectOwnerChange() {
      if (this.owner_contact_list.length > 0) {
        for (const [index, item] of this.owner_contact_list.entries()) {
          item.owner_address =
            item.address + " " + item.city + " " + item.country;
        }
      }
      //alert(id);
      // this.contact_owner_list.filter((item) => {
      //   if (item.contact_id == id) {
      //     this.owner_address =
      //       item.address + " " + item.city + " " + item.country;
      //     return item;
      //   }
      // });
    },
    async onSelectAgentChange(id) {
      let setdata;
      setdata = this.contact_agent_list.filter((item) => {
        if (item.contact_id == id) {
          console.log(item);
          this.itemdata.agent_email = item.email;
          this.agent_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectAssociateChange(id) {
      this.contact_associate_list.filter((item) => {
        if (item.contact_id == id) {
          this.associate_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },

  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },

    date_of_application(val) {
      this.itemdata.date_of_application = this.formatDate(
        this.date_of_application
      );
    },
    date_of_patent(val) {
      this.itemdata.date_of_patent = this.formatDate(this.date_of_patent);
    },
    international_filing_date(val) {
      this.itemdata.international_filing_date = this.formatDate(
        this.international_filing_date
      );
    },
    date_of_publishing(val) {
      this.itemdata.date_of_publishing = this.formatDate(
        this.date_of_publishing
      );
    },
    exam_request_date(val) {
      this.itemdata.exam_request_date = this.formatDate(this.exam_request_date);
    },
    exam_request_deadline(val) {
      this.itemdata.exam_request_deadline = this.formatDate(
        this.exam_request_deadline
      );
    },
    date_of_examination(val) {
      this.itemdata.date_of_examination = this.formatDate(
        this.date_of_examination
      );
    },
    next_deadline(val) {
      this.itemdata.next_deadline = this.formatDate(this.next_deadline);
    },
    last_annuity_paid(val) {
      this.itemdata.last_annuity_paid = this.formatDate(this.last_annuity_paid);
    },
    next_annuity_date(val) {
      this.itemdata.next_annuity_date = this.formatDate(this.next_annuity_date);
    },
    final_due_date_for_next_payment(val) {
      this.itemdata.final_due_date_for_next_payment = this.formatDate(
        this.final_due_date_for_next_payment
      );
    },
    next_renewal(val) {
      this.itemdata.next_renewal = this.formatDate(this.next_renewal);
    },
    last_renewal_att(val) {
      this.itemdata.last_renewal_att = this.formatDate(this.last_renewal_att);
    },
  },
};
